// extracted by mini-css-extract-plugin
export var fullHeightState = "_5a-7";
export var headerCell = "_5a-1";
export var loadingStateCell = "_5a-4";
export var rowWrapper = "_5a-3";
export var standaloneTable = "_5a-8";
export var standaloneTableWithBodyFill = "_5a-9";
export var stateCell = "_5a-5";
export var table = "_5a-0";
export var tableBodyFiller = "_5a-6";
export var white = "_5a-2";